import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { UiComponents, MoveIcon, ApplicationIcon, AngleDownIcon } from "@simulanisindia/ui";
import { useModalContext } from "../modal/context/ModalProvider";
import { checkPermissionExist, modalName } from "../utils/general";
import { DeleteIcons, UnassignIcon } from "../assets/Icons";
import { APPLICATION_TAB_TYPE, GROUP_TAB_TYPE, USER_TAB_TYPE } from "../constant/constants";
import {
  GROUP_CREATE_PERMISSION,
  GROUP_MOVE_PERMISSION,
  GROUP_STATUS_PERMISSION,
  RESOURCE_REVOKE_PERMISSION,
  USER_CREATE_PERMISSION,
  USER_MOVE_PERMISSION,
  USER_STATUS_PERMISSION,
} from "../constant/permission";

const { IconButton, SimTooltip, SimToggleSwitch, SimDropdownBasic, SimCheckBox, SimModal } = UiComponents;

const dropdownOptions = [
  { key: "all", label: "All" },
  { key: "none", label: "None" },
  { key: "active", label: "Active" },
  { key: "inactive", label: "Inactive" },
];

const movePermissionKey = {
  [GROUP_TAB_TYPE]: GROUP_MOVE_PERMISSION,
  [USER_TAB_TYPE]: USER_MOVE_PERMISSION,
};
const statusPermissionKey = {
  [GROUP_TAB_TYPE]: GROUP_STATUS_PERMISSION,
  [USER_TAB_TYPE]: USER_STATUS_PERMISSION,
};

const SelectionLine = ({
  handleClickMultipleSelect,
  handleClearSelection,
  triggerRefreshHandler,
  showAssignIcon = true,
  showMoveIcon = true,
  showStatusChangeIcon = true,
  buttonShow,
  text,
  multipleProfileStatusChange,
  type,
  selectedItems,
  totalItemsCount,
  showDropdown = true,
  showUnassignIcon = false,
  allSelectedItems = [],
  handelUnassignApplication,
  deleteButton,
  handleDeleteItemClicked,
}) => {
  const [status, setStatus] = useState("disabled");
  const { openModal } = useModalContext();
  const params = useParams();
  const navigate = useNavigate();

  const handleOptionClick = (option) => {
    handleClickMultipleSelect(option.key);
  };

  useEffect(() => {
    if (showStatusChangeIcon && selectedItems.every((group) => group.data.active === true)) {
      setStatus(true);
    } else if (showStatusChangeIcon && selectedItems.every((group) => group.data.active === false)) {
      setStatus(false);
    } else {
      setStatus("disable");
    }
  }, [showStatusChangeIcon, selectedItems]);

  const handleMultipleStatusChange = () => {
    let newStatus = !status;
    setStatus(newStatus);
    multipleProfileStatusChange(newStatus);
  };

  const selectAllClick = (e) => {
    handleClickMultipleSelect(e.target.checked ? "all" : "none");
  };

  const handleAssignAppClick = () => {
    let selectedData = {
      type: type,
      items: selectedItems.map((item) => ({ name: item.data.name, uuid: item.data.uuid, avatar: item.data.avatar })),
    };
    navigate(`/resource-management/${type}/${params.uuid}`, { state: { selectedData } });
  };

  const handleUnAssignTrigger = () => {
    openModal({
      modalName: modalName.CONFIRM_BOX,
      title: "Unassign resource",
      message: "Are you sure to unassign selected items.",
      confirmBtnName: "Confirm",
      handleConfirmClick: () => handelUnassignApplication(),
    });
  };

  return (
    <>
      <div className="selectionlineparent">
        <div className={`selectionline ${!buttonShow ? "justify-content-center py-3" : ""}`}>
          {buttonShow && (
            <div className={`selectionlinebtn`}>
              <div className="checkanddrp d-flex align-items-center gap-2">
                <SimCheckBox
                  onChange={selectAllClick}
                  checked={totalItemsCount > 0 && selectedItems?.length === totalItemsCount}
                />

                {showDropdown && (
                  <SimDropdownBasic
                    className="linecheckbtn"
                    labelIcon={<AngleDownIcon />}
                    data={dropdownOptions}
                    onOptionClick={handleOptionClick}
                  />
                )}
              </div>

              {deleteButton && (
                <>
                  <span className="deleteicon" onClick={handleDeleteItemClicked}>
                    <DeleteIcons />
                  </span>
                </>
              )}

              {showAssignIcon && selectedItems?.length > 0 && checkPermissionExist(RESOURCE_REVOKE_PERMISSION) && (
                <SimTooltip text="Assign Application" placement="top">
                  <div>
                    <IconButton Icon={<ApplicationIcon />} onClick={handleAssignAppClick} />
                  </div>
                </SimTooltip>
              )}

              {showUnassignIcon && allSelectedItems?.length > 0 && checkPermissionExist(RESOURCE_REVOKE_PERMISSION) && (
                <SimTooltip text="Unassign Application" placement="top">
                  <div>
                    <IconButton Icon={<UnassignIcon />} onClick={handleUnAssignTrigger} />
                  </div>
                </SimTooltip>
              )}

              {showMoveIcon && checkPermissionExist(movePermissionKey[type]) && (
                <SimTooltip text="Move" placement="top">
                  <div>
                    <IconButton
                      onClick={() =>
                        openModal({
                          modalName: modalName.GROUP_USER_MOVE,
                          params,
                          type: type,
                          transferData: selectedItems,
                          status: true,
                          handleRefreshTab: triggerRefreshHandler,
                          handleClearSelection,
                        })
                      }
                      Icon={<MoveIcon />}
                    />
                  </div>
                </SimTooltip>
              )}

              {showStatusChangeIcon && checkPermissionExist(statusPermissionKey[type]) && (
                <SimTooltip text="Active/Inactive" placement="top">
                  <div>
                    <SimToggleSwitch
                      checked={status === true}
                      disabled={status === "disable"}
                      onChange={handleMultipleStatusChange}
                    />
                  </div>
                </SimTooltip>
              )}
            </div>
          )}
          <p>{text}</p>
        </div>
      </div>
    </>
  );
};

export default SelectionLine;
